<template>
  <help-info-wrapper
    :info.sync="helpData"
    :service-name="serviceName"
    class="warp"
  >
    <template>
      <div>
        <custom-tabs v-model="tabs" grow class="mb-2 rounded-lg">
          <template v-slot:staticTabs>
            <v-tab
              v-for="(item, i) in mediaObj"
              :href="`#${i}`"
              :ripple="false"
              :key="i"
            >
              <div class="cornel-left"></div>
              <div class="cornel-right"></div>
              {{ item.title }}
              <help-info
                v-if="item && item.title"
                :element-name="`${serviceName}-${componentName}-tab-mediaObj-${i}`"
                :service-name="serviceName"
                :help-data="helpData"
                class="buttoninfo"
                :label="`${item.title}`"
              />
            </v-tab>
          </template>

          <template v-slot:staticItems>
            <v-tab-item v-for="(item, i) in mediaObj" :key="i" :value="i">
              <v-card flat class="d-flex flex-wrap pb-5">
                <template v-for="(media, j) in item.items">
                  <div class="rowinfo">
                    <v-tooltip
                      class="contentinfo"
                      bottom
                      :key="j"
                      :color="
                        media.attrs
                          ? media.attrs.hover
                            ? media.attrs.hover
                            : media.attrs.fgColor
                          : ''
                      "
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-hover v-slot="{ hover }" v-if="media.attrs">
                          <div
                            class="m-2 px-3 py-2 position-relative mt-10 qrBtn"
                            :style="
                              hover
                                ? `background: ${
                                    media.attrs.hover
                                      ? media.attrs.hover
                                      : media.attrs.fgColor
                                  }`
                                : ''
                            "
                            @click="addSocial(media)"
                            v-on="on"
                            v-bind="attrs"
                          >
                            <svg-base
                              class="mt-3"
                              :view-box="media.viewBox"
                              :width="media.width"
                              :height="media.height"
                            >
                              <component
                                :is="media.svg"
                                v-bind="hover ? media.attrs : ''"
                              />
                            </svg-base>
                            <v-chip
                              x-small
                              color="pink"
                              class="text-white"
                              v-if="media.soon"
                              style="
                                position: absolute;
                                bottom: -10px;
                                right: 4px;
                              "
                              >به زودی
                            </v-chip>
                          </div>
                        </v-hover>

                        <div
                          v-else
                          @click="addSocial(media)"
                          :key="media.value"
                          :class="
                            media.soon
                              ? 'pb-4 m-2 p-3 mt-10 qrBtn position-relative'
                              : 'm-2 p-3 mt-10 qrBtn position-relative'
                          "
                          v-on="on"
                          v-bind="attrs"
                        >
                          <v-chip
                            x-small
                            color="pink"
                            v-if="media.soon"
                            class="text-white"
                            style="
                              position: absolute;
                              bottom: -10px;
                              right: 6px;
                            "
                            >به زودی
                          </v-chip>
                          <img
                            :src="media.img"
                            :alt="media.text"
                            width="50"
                            style="aspect-ratio: 1; object-fit: cover"
                          />
                        </div>
                      </template>

                      <span>{{ media.soon ? "به زودی " : media.label }}</span>
                    </v-tooltip>
                    <help-info
                      :element-name="`${serviceName}-${componentName}-tooltipData`"
                      :service-name="serviceName"
                      :help-data="helpData"
                      style="padding-top: 90px !important"
                      class="buttoninfo"
                      label="مقدار"
                    />
                  </div>
                </template>
              </v-card>
            </v-tab-item>
          </template>
        </custom-tabs>

        <div
          v-if="Object.entries(socialMedia).length > 0"
          class="col-md-12 mt-3"
          style="border-bottom: 1px dashed #7e8299"
          v-for="(val, qual) in socialMedia"
          :key="qual"
        >
          <p>{{ val[0] ? val[0].label : "" }}</p>
          <div>
            <div v-for="(item, index) in val" :key="index">
              <v-text-field
                :error-messages="item.error"
                append-outer-icon="mdi-delete"
                :rules="item.prefix === 'URL' ? urlRules : ''"
                @click:append-outer="removeFromList(index, qual)"
                outlined
                dense
                v-model="item.url"
                :placeholder="item.hint"
                clearable
                v-bind="$attrs"
                clear-icon="mdi-close-circle-outline"
                style="direction: ltr"
                direction="ltr"
              >
                <template v-slot:prepend-inner>
                  <v-card
                    flat
                    height="40"
                    color="grey lighten-2"
                    class="d-flex align-center px-2"
                    width="fit-content"
                  >
                    <v-icon v-if="item.prefix.startsWith('mdi')">{{
                      item.prefix
                    }}</v-icon>
                    <span v-else>{{ item.prefix }}</span>
                  </v-card>
                </template>
                <template
                  v-slot:prepend
                  v-for="media in flattenObj.filter((x) => x.svg === item.svg)"
                >
                  <svg-base
                    class="mt-0"
                    v-if="media.attrs"
                    :view-box="media.viewBox"
                    :width="media.width"
                    :height="media.height"
                  >
                    <component class="mt-0" :is="media.svg" />
                  </svg-base>
                  <div
                    v-else
                    @click="addSocial(media)"
                    :class="
                      media.soon
                        ? 'pb-4 m-2 p-3 mt-10 qrBtn position-relative'
                        : 'm-2 p-3 mt-10 qrBtn position-relative'
                    "
                  >
                    <v-chip
                      x-small
                      color="pink"
                      v-if="media.soon"
                      class="text-white"
                      style="position: absolute; bottom: -10px; right: 6px"
                      >به زودی
                    </v-chip>
                    <img
                      :src="media.img"
                      :alt="media.text"
                      width="40"
                      style="object-fit: cover"
                    />
                  </div>
                </template>
              </v-text-field>
            </div>
          </div>
        </div>
      </div>
    </template>
  </help-info-wrapper>
</template>

<script>
import HelpInfo from "../../qrland/components/helpAcordion/HelpInfo.vue";
import HelpInfoWrapper from "../../qrland/components/helpAcordion/HelpInfoWrapper.vue";
import svgBase from "@/view/content/svgLoader/svgBase";
import svgFacebook from "@/view/content/svgLoader/svgFile/svgFacebook";
import svgDribbble from "@/view/content/svgLoader/svgFile/svgDribbble";
import svgPinterest from "@/view/content/svgLoader/svgFile/svgPinterest";
import svgTelegram from "@/view/content/svgLoader/svgFile/svgTelegram";
import svgWhatsapp from "@/view/content/svgLoader/svgFile/svgWhatsapp";
import svgInstagram from "@/view/content/svgLoader/svgFile/svgInstagram";
import svgGithub from "@/view/content/svgLoader/svgFile/svgGithub";
import svgTiktok from "@/view/content/svgLoader/svgFile/svgTiktok";
import svgEmail from "@/view/content/svgLoader/svgFile/svgEmail";
import svgLocation from "@/view/content/svgLoader/svgFile/svgLocation";
import svgEitaa from "@/view/content/svgLoader/svgFile/pr/svgEitaa";
import svgSoroush from "@/view/content/svgLoader/svgFile/pr/svgSoroush";
import svgBale from "@/view/content/svgLoader/svgFile/pr/svgBale";
import svgLinkedin from "@/view/content/svgLoader/svgFile/svgLinkedin";
import svgAparat from "@/view/content/svgLoader/svgFile/pr/svgAparat";
import svgGap from "@/view/content/svgLoader/svgFile/pr/svgGap";
import svgDivar from "@/view/content/svgLoader/svgFile/pr/svgDivar";
import svgSheypour from "@/view/content/svgLoader/svgFile/pr/svgSheypour";
import svgTwitter from "@/view/content/svgLoader/svgFile/svgTwitter";
import svgSkype from "@/view/content/svgLoader/svgFile/svgSkype";
import svgYoutube from "@/view/content/svgLoader/svgFile/svgYoutube";
import svgWechat from "@/view/content/svgLoader/svgFile/svgWechat";
import svgViber from "@/view/content/svgLoader/svgFile/svgViber";
import svgRubika from "@/view/content/svgLoader/svgFile/pr/svgRubika";
import QrAddressField from "@/view/content/fragments/qrAddressField";
import svgDigikala from "@/view/content/svgLoader/svgFile/pr/svgDigikala";
import svgBasalam from "@/view/content/svgLoader/svgFile/pr/svgBasalam";
import svgSnappshop from "@/view/content/svgLoader/svgFile/pr/svgSnappshop";
import svgTechnolife from "@/view/content/svgLoader/svgFile/pr/svgTechnolife";
import svgTorob from "@/view/content/svgLoader/svgFile/pr/svgTorob";
import svgEmalls from "@/view/content/svgLoader/svgFile/pr/svgEmalls";
import { Bus } from "@/main";

export default {
  name: "siteSelector",
  components: {
    HelpInfo,
    HelpInfoWrapper,
    QrAddressField,
    svgBase,
    svgFacebook,
    svgDribbble,
    svgPinterest,
    svgTelegram,
    svgWhatsapp,
    svgInstagram,
    svgGithub,
    svgTiktok,
    svgEmail,
    svgLocation,
    svgEitaa,
    svgSoroush,
    svgBale,
    svgLinkedin,
    svgAparat,
    svgGap,
    svgDivar,
    svgSheypour,
    svgTwitter,
    svgSkype,
    svgYoutube,
    svgWechat,
    svgViber,
    svgRubika,
    svgDigikala,
    svgBasalam,
    svgSnappshop,
    svgTechnolife,
    svgTorob,
    svgEmalls,
  },

  props: {
    value: {
      type: Object,
    },
  },
  data() {
    return {
      helpData: [],
      serviceName: "Qrland",
      componentName: "siteSelector",
      model: "",
      urlValue: "",
      count: 0,
      tabs: "otherLinks",
      mediaObj: {
        otherLinks: {
          title: "موتورهای جستجو و سایت ها",
          soon: false,
          items: [
            {
              label: "آدرس",
              soon: false,
              socialText: "",
              text: "لینک سایت مورد نظر را وارد نمایید",
              value: "address",
              svg: "svgLocation",
              pattern: "",
              error: "",
              prefix: "URL",
              img: "/media/socialIcon/40icon/location.svg",
              attrs: { bgColor: "#fff", hover: "#90caf9" },
            },
            {
              label: "نشان",
              soon: true,
              socialText: "",
              text: "نام کاربری خود را وارد نمایید",
              value: "neshan",
              pattern: "https://instagram.com/",
              error: "",
              prefix: "@",
              svg: "",
              img: "/media/images/neshan.webp",
              attrs: "",
            },
            {
              label: "بلد",
              soon: true,
              socialText: "",
              text: "نام کاربری خود را وارد نمایید",
              value: "balad",
              pattern: "https://instagram.com/",
              error: "",
              prefix: "@",
              svg: "",
              img: "/media/images/dnbQDQwjw2vAWW1.webp",
              attrs: "",
            },
            {
              label: "نقشه گوگل",
              soon: true,
              socialText: "",
              text: "نام کاربری خود را وارد نمایید",
              value: "map",
              pattern: "https://instagram.com/",
              error: "",
              prefix: "@",
              svg: "",
              img: "/media/images/google.webp",
              attrs: "",
            },
            {
              label: "پیندو",
              soon: true,
              socialText: "",
              text: "نام کاربری خود را وارد نمایید",
              value: "pindo",
              pattern: "https://instagram.com/",
              error: "",
              prefix: "@",
              svg: "",
              img: "/media/images/لوگو-پیندو-7.png",
              attrs: "",
            },
          ],
        },
        ads: {
          title: "سایت های تبلیغاتی",
          soon: false,
          items: [
            {
              label: "دیوار",
              socialText: "",
              soon: false,
              text: "لینک آگهی/پنل/فروشگاه خود را وارد نمایید",
              value: "divar",
              svg: "svgDivar",
              pattern: "",
              error: "",
              prefix: "URL",
              img: "/media/socialIcon/40icon/pr/divar.svg",
              attrs: { fgColor: "#fff", hover: "#a62626" },
              viewBox: "0 0 40 24.33",
            },
            {
              label: "شیپور",
              soon: true,
              socialText: "",
              text: "لینک آگهی/پنل/فروشگاه خود را وارد نمایید",
              value: "sheypoor",
              svg: "svgSheypour",
              pattern: "",
              error: "",
              prefix: "URL",
              img: "/media/socialIcon/40icon/pr/sheypour.svg",
              attrs: { fgColor: "#fff", hover: "#0073f3" },
              viewBox: 40,
            },
              {
              label: "دیجی کالا",
              text: "لینک دیجی کالا را وارد کنید",
              hint: "لینک دیجی کالا را وارد کنید",
              socialText: "",
              value: "digikala",
              svg: "svgDigikala",
              pattern: "",
              prefix: "URL",
              img: "/media/socialIcon/40icon/pr/digikala.svg",
              attrs: { fgColor: "#fff", hover: "#ef394e" },
              viewBox: "0.00 0.00 1080.00 1080.00"

            },
            {
              label: "باسلام",
              text: "لینک باسلام را وارد کنید",
              hint: "لینک باسلام را وارد کنید",
              socialText: "",
              value: "basalam",
              svg: "svgBasalam",
              pattern: "",
              prefix: "URL",
              img: "/media/socialIcon/40icon/pr/basalam.svg",
              attrs: { fgColor: "#fff", hover: "#FF5C39" },
              viewBox: "0 0 128 208"
            },
            {
              label: "اسنپ شاپ",
              text: "لینک اسنپ شاپ را وارد کنید",
              hint: "لینک اسنپ شاپ را وارد کنید",
              socialText: "",
              value: "snappshop",
              svg: "svgSnappshop",
              pattern: "",
              prefix: "URL",
              img: "/media/socialIcon/40icon/pr/snappshop.svg",
              attrs: { fgColor: "#fff", hover: "#B400AE" },
              viewBox:"0 0 69 40",
            },
            {
              label: "تکنولایف",
              text: "لینک تکنولایف را وارد کنید",
              hint: "لینک تکنولایف را وارد کنید",
              socialText: "",
              value: "technolife",
              svg: "svgTechnolife",
              pattern: "",
              prefix: "URL",
              img: "/media/socialIcon/40icon/pr/technolife.svg",
              attrs: { fgColor: "#fff", hover: "#26487e" },
              viewBox:"0 0 112 42"
            },
            {
              label: "ترب",
              text: "لینک ترب را وارد کنید",
              hint: "لینک ترب را وارد کنید",
              socialText: "",
              value: "torob",
              svg: "svgTorob",
              pattern: "",
              prefix: "URL",
              img: "/media/socialIcon/40icon/pr/torob.svg",
              attrs: { fgColor: "#fff", hover: "#d62020" },
              
              viewBox:"0.00 0.00 130.00 130.00",
            },
            {
              label: "ایمالز",
              text: "لینک ایمالز را وارد کنید",
              hint: "لینک ایمالز را وارد کنید",
              socialText: "",
              value: "emalls",
              svg: "svgEmalls",
              pattern: "",
              prefix: "URL",
              img: "/media/socialIcon/40icon/pr/Emalls.svg",
              attrs: { fgColor: "#fff", hover: "#fd564a" },
              viewBox:"0.00 0.00 300.00 78.00",
            },
          ],
        },
        foreignMedia: {
          title: "شبکه های اجتماعی خارجی",
          soon: false,
          items: [
            {
              label: "اینستاگرام",
              soon: true,
              socialText: "",
              text: "نام کاربری خود را وارد نمایید",
              value: "instagram",
              pattern: "https://instagram.com/",
              error: "",
              prefix: "@",
              svg: "svgInstagram",
              img: "/media/socialIcon/40icon/instagram.svg",
              attrs: { hover: "#cc39a4" },
            },
            {
              label: "تلگرام",
              soon: true,
              socialText: "",
              text: "نام کاربری خود را وارد نمایید",
              value: "telegram",
              svg: "svgTelegram",
              pattern: "https://t.me/",
              error: "",
              prefix: "@",
              img: "/media/socialIcon/40icon/telegram_app.svg",
              attrs: { bgColor: "#fff", fgColor: "#29b6f6" },
            },
          ],
        },
      },
      socialMedia: {},
      urlRules: [
        (value) =>
          this.isURL(value) ||
          " https://terminalads.com :   لینک سایت باید بصورت روبرو وارد شود",
      ],
    };
  },
  mounted() {
    let flattenMedia = [].concat(
      ...Object.values(this.mediaObj).map((item) => item.items)
    );

    this.$root.$on("clearDefaultData", this.clearDefaults);


    // Object.entries(this.value).forEach(([key, value]) => {
    //   value.forEach(item => {
    //     item.prefix = flattenMedia.find(item => item.value === key)?.prefix;
    //     item.pattern = flattenMedia.find(item => item.value === key)?.pattern;
    //   });
    // });

    // this.socialMedia = this.value
  },
  computed: {
    flattenObj() {
      let item = [];

      Object.entries(this.mediaObj).forEach(([key, value]) => {
        item.push(...value.items);
      });
      return item;
    },
  },

  watch: {
    socialMedia: {
      handler(val) {
        this.$emit("input", val);
      },
      deep: true,
    },
  },

  methods: {
    isURL(str) {
      var regex = new RegExp(
        "^(http[s]?:\\/\\/(www\\.)?|ftp:\\/\\/(www\\.)?|www\\.){1}([0-9A-Za-z-\\.@:%_\+~#=]+)+((\\.[a-zA-Z]{2,3})+)(/(.)*)?(\\?(.)*)?"
      );
      var without_regex = new RegExp(
        "^([0-9A-Za-z-\\.@:%_\+~#=]+)+((\\.[a-zA-Z]{2,3})+)(/(.)*)?(\\?(.)*)?"
      );
      if (regex.test(str) || without_regex.test(str)) {
        return true;
      } else {
        return false;
      }
    },
    addSocial(media) {
      if (!media.soon && this.count !== 1) {
        if (!Object.hasOwn(this.socialMedia, media.value)) {
          let tempObject = {};
          tempObject[media.value] = [];
          this.count = 1;

          this.socialMedia = {
            ...this.socialMedia,
            ...tempObject,
          };
        }

        let obj = {
          hint: media.text,
          label: media.label,
          url: "",
          soon: false,
          prefix: media.prefix,
          pattern: media.pattern,
          img: media.img,
          error: "",
          socialText: "",
        };
        if (media.svg) {
          obj.svg = media.svg;
        }

        this.socialMedia[media.value].push(obj);
      } else if (!media.soon && this.count >= 1) {
        this.count = 0;
        this.socialMedia = {};
        this.addSocial(media);
      } else this.$toast.info("این آیتم غیرفعال است و به زودی فعال می گردد.");
    },
    removeFromList(value, key) {
      this.count = 0;
      this.socialMedia[key].splice(value, 1);
      if (this.socialMedia[key].length <= 0) {
        delete this.socialMedia[key];
      }
    },
    clearDefaults() {
      this.socialMedia = {};
      this.$nextTick(() => {
        console.log(this.socialMedia);
      });
    },
  },
};
</script>

<style scoped>
.v-tabs >>> .v-tabs-slider-wrapper {
  display: block !important;
}

.qrBtn {
  border-radius: 4px !important;
  box-shadow: 4px 3px 5px rgba(2, 16, 92, 0.3);
  cursor: pointer;
  transition: all 0.15s ease-in-out;
}

.qrBtn:hover {
  border-radius: 8px !important;
  box-shadow: 8px 5px 10px #02105c8c !important;
}

.v-input >>> .v-input__slot {
  padding-left: 0 !important;
}

.v-input >>> .v-input__prepend-inner {
  margin: 0 !important;
  padding-left: 0;
  padding-right: 4px;
}

.v-input >>> .v-input__prepend-outer {
  margin: 0 !important;
  padding-right: 4px;
}

.v-input >>> .v-input__append-inner {
  padding-left: 15px !important;
}

.v-btn:before,
.v-btn:hover:before {
  opacity: 0 !important;
}
</style>
